<template lang="pug">
modal(
  :active='active',
  title='Incluir Serviços Extras',
  @close='$emit("close")'
)
  div(slot='modal-body')
    .columns
      .column.col-5.col-sm-12
        form-group(label='Horas trabalhadas', :validation='$v.params.horas')
          money.form-input(v-model='$v.params.horas.$model')
      .column.col-5.col-sm-12
        form-group(
          label='Pontos por Hora',
          :validation='$v.params.pontos_por_hora'
        )
          money.form-input(v-model.number='$v.params.pontos_por_hora.$model')
      .column.col-2.col-sm-12
        form-group(label='Pontos')
          .form-input {{ params.horas * params.pontos_por_hora }}
    form-group(label='Descrição', :validation='$v.params.descricao')
      input.form-input(v-model='$v.params.descricao.$model')
  div(slot='modal-footer')
    button.btn.btn-primary(
      :class='{ loading: loading }',
      @click='save',
      :disabled='$v.$invalid || loading'
    )
      btn-content(name='save')
</template>

<script>
import { deepKey } from 'paliari-js-utils'
import {
  maxLength,
  minLength,
  required,
  minValue,
} from 'vuelidate/lib/validators'
import api from '@/api/produtividade/pontuacoes'

export default {
  props: {
    resumo: { type: Object, required: true },
    active: { type: Boolean, required: true },
  },

  data() {
    return {
      loading: false,
      params: {
        horas: 0,
        pontos_por_hora: 0,
        descricao: '',
      },
    }
  },

  methods: {
    save() {
      this.loading = true
      api
        .createServicoExtra(this.resumo.id, this.params)
        .then((res) => {
          this.$toaster.success('Salvo com sucesso.')
          this.loading = false
          this.$emit('close', res)
        })
        .catch((e) => {
          this.$toaster.error(e.message)
          this.loading = false
        })
    },
  },

  mounted() {
    const pontosPorHora = deepKey(
      this.resumo,
      'pontuacao_geral.params.pontos_por_hora_servico_extra',
    )
    if (pontosPorHora) {
      this.params.pontos_por_hora = pontosPorHora
    }
  },

  validations: {
    params: {
      horas: { required, minValue: minValue(0.01) },
      pontos_por_hora: { required, minValue: minValue(0.01) },
      descricao: {
        required,
        minLength: minLength(5),
        maxLength: maxLength(100),
      },
    },
  },
}
</script>
